import React, { Component } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { Urls } from '../../Urls'
import './ReviewScreen.css'
import Axios from 'axios'
import Loader from '../Loader'
import { constants } from '../../constants'
import { logActivity } from '../Utilities'
var current_row = 0
var raw_locationData = {}
var raw_vendorData = {}
var raw_truckData = {}
export class ReviewScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataset_id: '',
            isLoading: false,
            locationData: undefined,
            locationSearch: [],
            vendorData: undefined,
            vendorSearch: undefined,
            truckData: undefined,
            truckSearch: undefined,
            screenName: 'location',
            metadata: {},
            comment: ''
        }
    }


    getDataset = () => {
        if (sessionStorage.getItem('review-dataset')) {
            this.setState({
                dataset_id: sessionStorage.getItem('review-dataset')
            })
        }
        else {
            this.setState({
                dataset_id: localStorage.getItem('dataset_id')
            })
        }
    }

    changeHandler = event => {
        let metadata = this.state.metadata
        metadata[event.target.name] = event.target.value
        this.setState({
            metadata: metadata
        })
    }

    componentDidMount() {
        this.getDataset()
        // logActivity([
        //     {
        //         'screen': 'Dataset Review',
        //         'module': 'Dataset Review',
        //         'user_activity': `Review for ${this.state.dataset_id ? this.state.dataset_id : sessionStorage.getItem('review-dataset')}`,
        //         'timestamp': new Date().toISOString
        //     }
        // ])
        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
        document.getElementById('header').style.opacity = 0.5
        this.setState({
            isLoading: true
        }, () => {
            Axios.post(Urls.review.fetching, { 'dataset_id': this.state.dataset_id, 'key': 'location' })
                .then(res => {
                    console.log(res.data)
                    this.setState({
                        locationData: res.data
                    })
                    raw_locationData = this.state.locationData
                })
                .catch(error => {
                    console.log(error)
                    document.getElementById('header').style.opacity = 1
                    this.setState({
                        isLoading: false
                    })
                    toast.error('Error while processing your request')
                })
            Axios.post(Urls.review.fetching, { 'dataset_id': this.state.dataset_id, 'key': 'vendor' })
                .then(res => {
                    console.log(res.data)
                    this.setState({
                        vendorData: res.data
                    })
                    raw_vendorData = this.state.vendorData
                })
                .catch(error => {
                    console.log(error)
                    document.getElementById('header').style.opacity = 1
                    this.setState({
                        isLoading: false
                    })
                    toast.error('Error while processing your request')
                })
            Axios.post(Urls.review.fetching, { 'dataset_id': this.state.dataset_id, 'key': 'truck' })
                .then(res => {
                    console.log(res.data)
                    document.getElementById('header').style.opacity = 1
                    this.setState({
                        isLoading: false,
                        truckData: res.data
                    })
                    raw_truckData = this.state.truckData
                })
                .catch(error => {
                    console.log(error)
                    document.getElementById('header').style.opacity = 1
                    this.setState({
                        isLoading: false
                    })
                    toast.error('Error while processing your request')
                })
            Axios.post(Urls.review.fetching, { 'dataset_id': this.state.dataset_id, 'key': 'metadata' })
                .then(res => {
                    console.log(res.data)
                    document.getElementById('header').style.opacity = 1
                    this.setState({
                        metadata: res.data.data,
                        isLoading: false
                    })
                })
                .catch(error => {
                    console.log(error)
                    document.getElementById('header').style.opacity = 1
                    this.setState({
                        isLoading: false
                    })
                    toast.error('Error while processing your request')
                })

        })

        document.getElementById('reviewname').innerHTML = 'Location'

        document.getElementById('location').style.display = 'block'
        document.getElementById('locationButton').style.backgroundColor = '#dc3545'

        document.getElementById('vendor').style.display = 'none'
        document.getElementById('vendorButton').style.backgroundColor = '#007bff'

        document.getElementById('truck').style.display = 'none'
        document.getElementById('truckButton').style.backgroundColor = '#007bff'

        document.getElementById('metadata').style.display = 'none'
        document.getElementById('metadataButton').style.backgroundColor = '#007bff'
    }

    locationReviewSelected = () => {
        this.setState({ screenName: 'location' })
        document.getElementById('reviewname').innerHTML = 'Location'

        document.getElementById('location').style.display = 'block'
        document.getElementById('locationButton').style.backgroundColor = '#dc3545'

        document.getElementById('vendor').style.display = 'none'
        document.getElementById('vendorButton').style.backgroundColor = '#007bff'

        document.getElementById('truck').style.display = 'none'
        document.getElementById('truckButton').style.backgroundColor = '#007bff'

        document.getElementById('metadata').style.display = 'none'
        document.getElementById('metadataButton').style.backgroundColor = '#007bff'
    }

    vendorReviewSelected = () => {
        this.setState({ screenName: 'vendor' })
        document.getElementById('reviewname').innerHTML = 'Vendor'

        document.getElementById('vendor').style.display = 'block'
        document.getElementById('vendorButton').style.backgroundColor = '#dc3545'

        document.getElementById('location').style.display = 'none'
        document.getElementById('locationButton').style.backgroundColor = '#007bff'

        document.getElementById('truck').style.display = 'none'
        document.getElementById('truckButton').style.backgroundColor = '#007bff'

        document.getElementById('metadata').style.display = 'none'
        document.getElementById('metadataButton').style.backgroundColor = '#007bff'
    }

    truckReviewSelected = () => {
        this.setState({ screenName: 'truck' })
        document.getElementById('reviewname').innerHTML = 'Truck'

        document.getElementById('truck').style.display = 'block'
        document.getElementById('truckButton').style.backgroundColor = '#dc3545'

        document.getElementById('location').style.display = 'none'
        document.getElementById('locationButton').style.backgroundColor = '#007bff'

        document.getElementById('vendor').style.display = 'none'
        document.getElementById('vendorButton').style.backgroundColor = '#007bff'

        document.getElementById('metadata').style.display = 'none'
        document.getElementById('metadataButton').style.backgroundColor = '#007bff'
    }



    metadataReviewSelected = () => {
        this.setState({ screenName: 'metadata' })
        document.getElementById('reviewname').innerHTML = 'Metdata'

        document.getElementById('metadata').style.display = 'block'
        document.getElementById('metadataButton').style.backgroundColor = '#dc3545'

        document.getElementById('truck').style.display = 'none'
        document.getElementById('truckButton').style.backgroundColor = '#007bff'

        document.getElementById('location').style.display = 'none'
        document.getElementById('locationButton').style.backgroundColor = '#007bff'

        document.getElementById('vendor').style.display = 'none'
        document.getElementById('vendorButton').style.backgroundColor = '#007bff'
    }

    modifyLocationData = (event) => {

        current_row = parseInt(event.target.name)
        if (event.target.value !== "" && ((event.target.value.length % 3) === 0)) {
            Axios.get(`${Urls.autocomplete}?country=INDIA&limit=10&suggest=${event.target.value}&searchFields=locations`)
                .then(res => {
                    this.setState({
                        locationSearch: res.data.value
                    })
                })
                .catch(error => {
                    console.log(error)
                })
        }
        raw_locationData.data[event.target.name]['location'] = event.target.value
        this.setState({
            locationData: raw_locationData
        })
    }

    modifyVendorData = (event) => {
        raw_vendorData.data[event.target.name]['Map'] = event.target.value
        this.setState({
            vendorData: raw_vendorData
        })
    }

    modifyTruckData = (event) => {
        raw_truckData.data[event.target.name]['Map'] = event.target.value
        this.setState({
            truckData: raw_truckData
        }, this.getSumamry(event.target.name))
    }

    getSumamry(index) {
        console.log(this.state.truckData.data[index])
    }

    dumpData(screenName) {

        switch (screenName) {
            case 'location':
                if (this.state.locationData.data.length === 0) {
                    alert('You have no Location data to submit')
                }
                else {
                    document.getElementById('review_dump').disabled = false
                    var patternStatus = true
                    var input = []
                    var i = 0
                    for (i = 0; i < this.state.locationData.data.length; i++) {
                        input.push({
                            'user_input': this.state.locationData.data[i]['location']
                        })
                    }
                    for (i = 0; i < input.length; i++) {
                        if (!new RegExp(constants.regex_patterns.location).test(input[i]['user_input'])) {
                            document.getElementById(i).style.border = '1px solid red'
                            patternStatus = false
                        }
                        else {
                            document.getElementById(i).style.border = 'none'
                        }
                    }
                    if (!patternStatus) { alert(`Please enter correct data. Ex. City, District, State`) }
                    else {
                        document.getElementById('header').style.opacity = 0.5
                        this.setState({
                            isLoading: true
                        }, () => {
                            Axios.post(Urls.review.dumping, { 'dataset_id': this.state.dataset_id, 'key': 'location', 'input': input })
                                .then(res => {
                                    toast.success('Data has been dumped to database')
                                    document.getElementById('header').style.opacity = 1
                                    this.setState({ isLoading: false })

                                    this.setState({ screenName: 'vendor' })
                                    document.getElementById('reviewname').innerHTML = 'Vendor'

                                    document.getElementById('vendor').style.display = 'block'
                                    document.getElementById('vendorButton').style.backgroundColor = '#dc3545'

                                    document.getElementById('location').style.display = 'none'
                                    document.getElementById('locationButton').style.backgroundColor = '#007bff'

                                    document.getElementById('truck').style.display = 'none'
                                    document.getElementById('truckButton').style.backgroundColor = '#007bff'
                                })
                                .catch(error => {
                                    console.log(error)
                                    document.getElementById('header').style.opacity = 1
                                    this.setState({ isLoading: false })
                                    toast.error('Error while processing your request')
                                })
                        })
                    }
                }

                // console.log(input);
                break;
            case 'vendor':
                if (this.state.vendorData.data.length === 0) {
                    alert('You have no Vendor data to submit')
                }
                else {
                    document.getElementById('review_dump').disabled = false
                    var input = []
                    var i = 0
                    for (i = 0; i < this.state.vendorData.data.length; i++) {
                        input.push({
                            'user_input': this.state.vendorData.data[i]['Map']
                        })
                    }
                    document.getElementById('header').style.opacity = 0.5
                    this.setState({
                        isLoading: true
                    }, () => {
                        Axios.post(Urls.review.dumping, { 'dataset_id': this.state.dataset_id, 'key': 'vendor', 'input': input })
                            .then(res => {
                                toast.success('Data has been dumped to database')
                                document.getElementById('header').style.opacity = 1
                                this.setState({ isLoading: false })

                                this.setState({ screenName: 'truck' })
                                document.getElementById('reviewname').innerHTML = 'Truck'

                                document.getElementById('truck').style.display = 'block'
                                document.getElementById('truckButton').style.backgroundColor = '#dc3545'

                                document.getElementById('location').style.display = 'none'
                                document.getElementById('locationButton').style.backgroundColor = '#007bff'

                                document.getElementById('vendor').style.display = 'none'
                                document.getElementById('vendorButton').style.backgroundColor = '#007bff'
                            })
                            .catch(error => {
                                console.log(error)
                                document.getElementById('header').style.opacity = 1
                                this.setState({ isLoading: false })
                                toast.error('Error while processing your request')
                            })
                    })
                }
                // console.log(input); 
                break;
            case 'truck':
                if (this.state.truckData.data.length === 0) {
                    alert('You have no Truck data to submit')
                }
                else {
                    document.getElementById('review_dump').disabled = false
                    var input = []
                    var i = 0
                    for (i = 0; i < this.state.truckData.data.length; i++) {
                        input.push({
                            'user_input': this.state.truckData.data[i]['Map']
                        })
                    }
                    document.getElementById('header').style.opacity = 0.5
                    this.setState({
                        isLoading: true
                    }, () => {
                        Axios.post(Urls.review.dumping, { 'dataset_id': this.state.dataset_id, 'key': 'truck', 'input': input })
                            .then(res => {
                                toast.success('Data has been dumped to database')
                                document.getElementById('header').style.opacity = 1
                                this.setState({ isLoading: false })
                                this.props.history.push({ pathname: '/FinalConsolidation' })
                            })
                            .catch(error => {
                                console.log(error)
                                document.getElementById('header').style.opacity = 1
                                this.setState({ isLoading: false })
                                toast.error('Error while processing your request')
                            })
                    })
                }
                // console.log(input); 
                break;

            case 'metadata':
                document.getElementById('header').style.opacity = 0.5
                this.setState({
                    isLoading: true
                }, () => {
                    var input = { 'comment': this.state.metadata['comment'], 'Company': this.state.metadata['Company'] }
                    Axios.post(Urls.review.dumping, { 'dataset_id': this.state.dataset_id, 'key': 'metadata', 'input': input })
                        .then(res => {
                            toast.success('Data has been dumped to database')
                            document.getElementById('header').style.opacity = 1
                            this.setState({ isLoading: false })
                            this.props.history.push({ pathname: '/summaryScreen' })
                        })
                        .catch(error => {
                            console.log(error)
                            document.getElementById('header').style.opacity = 1
                            this.setState({ isLoading: false })
                            toast.error('Error while processing your request')
                        })
                })
                break;
        }
    }

    goBack = () => {
        this.props.history.push({
            pathname: "/summaryScreen"
        })
    }

    checkLocationMatching = (locationToVerify) => {
        if (locationToVerify['location'].includes('nan')) return 'errorRow'
        else if (!locationToVerify['location'].toLowerCase().includes(locationToVerify['Raw Location'].toLowerCase())) return 'errorRow'
        else if (!locationToVerify['location'].toLowerCase().includes(locationToVerify['Raw State'].toLowerCase())) return 'errorRow'
        else return ''
    }

    render() {
        var c_row = current_row
        var searchItems = this.state.locationSearch
        const sectors = ['FMCD', 'FMCG', 'CEMENT', 'AUTOMOBILE', 'STEEL', 'BREWING', 'BUILDING MATERIAL', , 'AGRICULTURAL', 'CEREMICS',
            'CHEMICAL', 'CONSTRUCTION', 'ECOMMERCE', 'ELECTRICALS', 'ELECTRONICS', 'ENGINEERING SERVICES', 'FASHION & CLOTHING', 'GLASS', 'HEALTHCARE',
            'INDUSTRIAL AUTOMATION', 'INFRASTRUCTURE', 'LOGISTICS', 'LUGGAGE', 'MANUFACTURING', 'MANUFACTURING EXCUTION SYSTEM', 'METALS & MINING',
            'OIL & GAS', 'PACKAGING', 'PAINTS', 'PAPER', 'PHARMCEUTICALS', 'PLASTICS', 'PRINTING & MINTING', 'RAW MATERIAL', 'TECHNOLOGY', 'TELECOM',
            'TEXTILE', 'TYRE']
        return (
            <div id="header">
                <ToastContainer />
                <div align="center" className="jumbotron row">
                    <div className="col-md-4 col-lg-4">
                        <button className="btn btn-danger" onClick={this.goBack}>Go to summary</button>
                    </div>
                    <div className="col-md-4 col-lg-4">
                        <h3 style={{ marginTop: '0.5%' }}>Review Screen: <span id="reviewname"></span></h3>
                    </div>
                    <div className="col-md-4 col-lg-4">
                        <button id="review_dump" className="btn btn-success" onClick={() => this.dumpData(this.state.screenName)}>Submit</button>
                    </div>
                </div>
                <div align="center" className="row">
                    <div style={{ marginBottom: '1%' }} className="row col-md-12 col-lg-12">
                        <div className="col-md-3 col-lg-3 col-sm-12 col-sm-12">
                            <button onClick={this.locationReviewSelected} style={{ borderColor: '#FFFFFF' }} id="locationButton" className="btn btn-primary">Review Location</button>
                        </div>
                        <div className="col-md-3 col-lg-3 col-sm-12 col-sm-12">
                            <button onClick={this.vendorReviewSelected} style={{ borderColor: '#FFFFFF' }} id="vendorButton" className="btn btn-primary">Review Vendor</button>
                        </div>
                        <div className="col-md-3 col-lg-3 col-sm-12 col-sm-12">
                            <button onClick={this.truckReviewSelected} style={{ borderColor: '#FFFFFF' }} id="truckButton" className="btn btn-primary">Review Truck</button>
                        </div>
                        <div className="col-md-3 col-lg-3 col-sm-12 col-sm-12">
                            <button onClick={this.metadataReviewSelected} style={{ borderColor: '#FFFFFF' }} id="metadataButton" className="btn btn-primary">Review Metadata</button>
                        </div>
                    </div>
                </div>
                <div id="location" className="body" align="center">
                    <table border="1" width="150%">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Raw Location</th>
                                <th>Raw State</th>
                                <th>Cleaned Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (!this.state.locationData || this.state.locationData.data.length === 0) ? (
                                    <tr>
                                        <td colSpan="4">
                                            No Data
                                        </td>
                                    </tr>
                                ) : (
                                        this.state.locationData.data.map((location, i) => <tr className={this.checkLocationMatching(location)}>
                                            <td>
                                                {i + 1}
                                            </td>
                                            <td>
                                                {location['Raw Location']}
                                            </td>
                                            <td>
                                                {location['Raw State']}
                                            </td>
                                            <td>
                                                <input id={i} list="auto" className="form-control" name={i} value={location['location']} onChange={this.modifyLocationData} />
                                                {
                                                    (c_row === i) ? (
                                                        // console.log(`Current Row: ${c_row} & 'Current Datalist row ${parseInt(i)}`)
                                                        <datalist name={i} id="auto">
                                                            {
                                                                (searchItems.length === 0 || searchItems === undefined) ? (<option>No location found!</option>) : (
                                                                    searchItems.map(item => (
                                                                        <option value={`${item.location.location}, ${item.location.district}, ${item.location.state}, ${item.location.lat}, ${item.location.lon}`}>
                                                                            {`${item.location.location}, ${item.location.district}, ${item.location.state}`}
                                                                        </option>
                                                                    )
                                                                    ))
                                                            }
                                                        </datalist>
                                                    ) : (null)
                                                }

                                            </td>
                                        </tr>)
                                    )
                            }
                        </tbody>
                    </table>
                </div>
                <div id="vendor" className="body" align="center">
                    <table border="1" width="150%">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Raw Vendor</th>
                                <th>Cleaned Vendor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (!this.state.vendorData || this.state.vendorData.data.length === 0) ? (
                                    <tr>
                                        <td colSpan="4">
                                            No Data
                                        </td>
                                    </tr>
                                ) : (
                                        this.state.vendorData.data.map((vendor, i) => <tr>
                                            <td>
                                                {i + 1}
                                            </td>
                                            <td>
                                                {vendor['Vendor']}
                                            </td>
                                            <td>
                                                <input list="vendor_search" onChange={this.modifyVendorData} className="form-control" name={i} value={vendor['Map']} />
                                                <datalist id="vendor_search">
                                                    {
                                                        this.state.vendorData.search.map(s => <option value={s}> {s} </option>)
                                                    }
                                                </datalist>
                                            </td>
                                        </tr>)
                                    )
                            }
                        </tbody>
                    </table>
                </div>
                <div id="truck" className="body" align="center">
                    <table border="1" width="150%">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Raw Truck Type</th>
                                <th>Cleaned Truck Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (!this.state.truckData || this.state.truckData.data.length === 0) ? (
                                    <tr>
                                        <td colSpan="4">
                                            No Data
                                </td>
                                    </tr>
                                ) : (
                                        this.state.truckData.data.map((truck, i) => <tr>
                                            <td>
                                                {i + 1}
                                            </td>
                                            <td>
                                                {truck['Truck']}
                                            </td>
                                            <td>
                                                <input list="truck_search" onChange={this.modifyTruckData} className="form-control" name={i} value={truck['Map']} />
                                                <datalist id="truck_search">
                                                    {
                                                        this.state.truckData.search.map(s => <option value={s}> {s} </option>)
                                                    }
                                                </datalist>
                                            </td>
                                        </tr>)
                                    )
                            }
                        </tbody>
                    </table>
                </div>

                <div id='metadata'>
                    <h4>Metadata review</h4>
                    <div className='row'>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Company Name:
                                    </span>
                                </div>
                                <div className='col-12 form-group'>
                                    {
                                        this.state.metadata['Company'] ? (
                                            <>
                                                <input className='form-control' disabled={true} value={this.state.metadata['Company']} />
                                            </>
                                        ) : (
                                                <span>Loading</span>
                                            )
                                    }

                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Data Cycle:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['Data Cycle'] ? (
                                                <select disabled={true} required id="data_cycle" name="data_cycle" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['Data Cycle'] === 'Annual' ? true : false} selected value="AD"> Annual </option>
                                                    <option selected={this.state.metadata['Data Cycle'] === 'Half yearly' ? true : false} value="HD"> Half yearly </option>
                                                    <option selected={this.state.metadata['Data Cycle'] === 'Quarterly' ? true : false} value="QD"> Quarterly </option>
                                                    <option selected={this.state.metadata['Data Cycle'] === 'Monthly' ? true : false} value="MD"> Monthly </option>
                                                    <option selected={this.state.metadata['Data Cycle'] === 'Daily Dispatch' ? true : false} value="DD"> Daily Dispatch </option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Mode:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['Mode'] ? (
                                                <select disabled required id="trans" name="transportation" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['Mode'] === 'Rail' ? true : false} value="02"> Rail </option>
                                                    <option selected={this.state.metadata['Mode'] === 'Sea' ? true : false} value="03"> Sea </option>
                                                    <option selected={this.state.metadata['Mode'] === 'Multi-modal' ? true : false} value="04"> Multi-modal </option>
                                                    <option selected={this.state.metadata['Mode'] === 'Air' ? true : false} value="05"> Air </option>
                                                    <option selected={this.state.metadata['Mode'] === 'Road' ? true : false} value="01"> Road </option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='row'>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Recieved Date:
                                    </span>
                                </div>
                                <div className='col-12 form-group'>
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['Received Date'] ? (
                                                <input disabled className='form-control' placeholder='Recieved Date' value={this.state.metadata['Received Date']} />
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }

                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Type of Data:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['Type of Data'] ? (
                                                <select disabled id="data_type" name="data_type" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['Type of Data'] === 'Primary' ? true : false} value="Primary"> Primary </option>
                                                    <option selected={this.state.metadata['Type of Data'] === 'Secondary' ? true : false} value="Secondary"> Secondary </option>
                                                    <option selected={this.state.metadata['Type of Data'] === 'Last Mile Transportation' ? true : false} value="Last Mile Transportation">Last Mile Transportation</option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Cargo Type:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['cargo_type'] ? (
                                                <select disabled required id="cargo_type" name="cargo_type" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['cargo_type'] === 'Reefer'} value="Reefer"> Reefer </option>
                                                    <option selected={this.state.metadata['cargo_type'] === 'Ambient'} value="Ambient"> Ambient </option>
                                                    <option selected={this.state.metadata['cargo_type'] === 'Temperature Controlled'} value="Temprature Controlled"> Temperature Controlled </option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='row'>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Country:
                                    </span>
                                </div>
                                <div className='col-12 form-group'>
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['country'] ? (
                                                <select disabled required id="country" name="country" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['country'] === 'INDIA' ? true : false} value="INDIA"> India </option>
                                                    <option selected={this.state.metadata['country'] === 'AUSTRALIA' ? true : false} value="AUSTRALIA"> Australia </option>
                                                    <option selected={this.state.metadata['country'] === 'CHINA' ? true : false} value="CHINA"> China </option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Currency:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['currency'] ? (
                                                <select disabled required id="currency" name="currency" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['currency'] === 'INR' ? true : false} value="INR"> INR </option>
                                                    <option selected={this.state.metadata['currency'] === 'AUD' ? true : false} value="AUD"> Australian Dollar </option>
                                                    <option selected={this.state.metadata['currency'] === 'CNY' ? true : false} value="CNY">Chinese Yuan</option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Metric Rate:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['metric_rate'] ? (
                                                <select disabled required id="metric_rate" name="metric_rate" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['metric_rate'] === 'PTPK' ? true : false} value="PTPK"> PTPK </option>
                                                    <option selected={this.state.metadata['metric_rate'] === 'Per Truck Load' ? true : false} value="Per Truck Load"> Per Truck Load </option>
                                                    <option selected={this.state.metadata['metric_rate'] === 'PMT' ? true : false} value="PMT"> PMT </option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='row'>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Sector:
                                    </span>
                                </div>
                                <div className='col-12 form-group'>
                                    {
                                        !this.state.isLoading ? (
                                            this.state.metadata['sector'] ? (
                                                <select disabled required name="sector" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    {
                                                        sectors.map(s => <option selected={this.state.metadata['sector'] === s ? true : false} value={s}>{s}</option>)
                                                    }
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Volume Unit:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    {
                                        !this.state.isLoading ? (

                                            this.state.metadata['volumeUnit'] ? (
                                                <select disabled required id="unit" name="unit" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                                    <option selected={this.state.metadata['volumeUnit'] === 'Truck Load' ? true : false} value="Truck Load"> Truck Load </option>
                                                    <option selected={this.state.metadata['volumeUnit'] === 'Per MT' ? true : false} value="Per MT"> Per MT </option>
                                                    <option selected={this.state.metadata['volumeUnit'] === 'Cubic Feet' ? true : false} value="Cubic Feet"> Cubic Feet </option>
                                                </select>
                                            ) : (
                                                    <span>No data</span>
                                                )
                                        ) : <span>Loading...</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-4 col-sm-6 col-xs-12'>
                            <div className='row'>
                                <div className='col-12 text-left input-label'>
                                    <span className='form-label'>
                                        Comment:
                                    </span>
                                </div>
                                <div className="form-group col-12">
                                    <textarea className="form-control" rows="2" placeholder="Enter comment if any" columns="10" value={this.state.metadata.comment ? this.state.metadata.comment : ''} name="comment" onChange={this.changeHandler} />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <Loader isLoading={this.state.isLoading} />
            </div >
        )
    }
}

export default ReviewScreen
